import { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  isFetchingProducts,
  getFetchProductsFailure,
  isSuccessFetchProducts,
  actions,
  getProducts,
  getProductsCurrentPage,
  getProductsPerPage,
  getProductFilter
} from "../modules/market";
import qs from "qs";

export default function useFetchProducts({ dealerId }) {
  const loading = useSelector(isFetchingProducts);
  const failure = useSelector(getFetchProductsFailure);
  const success = useSelector(isSuccessFetchProducts);
  const products = useSelector(getProducts);
  const currentPage = useSelector(getProductsCurrentPage);
  const perPage = useSelector(getProductsPerPage);
  const filter = useSelector(getProductFilter);

  const dispatch = useDispatch();

  const fetchProducts = useCallback(
    ({ dealerId, query }) => {
      dispatch(actions.fetchProducts({ dealer_id: dealerId, query }));
    },
    [dispatch]
  );

  useEffect(() => {
    if (dealerId) {
      fetchProducts({
        dealerId,
        query: qs.stringify(
          { ...filter, page: currentPage, per_page: perPage },
          { addQueryPrefix: true, encode: false }
        )
      });
    }
  }, [currentPage, dealerId, dispatch, fetchProducts, perPage, filter]);

  return {
    loading: loading,
    failure: failure,
    success: success,
    products
  };
}
